import { u32 } from '@polkadot/types';

export function transformU32ToBigint(value: u32): bigint {
  return value.toBigInt();
}
